import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import { BadgeBackground, BadgeImage, BadgeImageWrapper, LottieBadgeWrapper } from "./BadgePreview.styled";
export const BadgePreview = ({ iconUrl, isLocked = false }) => {
    return (_jsx(BadgeBackground, { children: _jsx(BadgeImageWrapper, { children: /lottiefiles.*\.json$/gi.test(iconUrl) ? (_jsx(LottieBadgeWrapper, { isLocked: isLocked, children: _jsx(Player, { src: iconUrl, loop: !isLocked, autoplay: !isLocked }) })) : (_jsx(BadgeImage, { src: iconUrl })) }) }));
};
